// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-37b9d0a8]{font-size:1.6rem;letter-spacing:normal}.italic[data-v-37b9d0a8]{font-style:italic}.bold[data-v-37b9d0a8]{font-weight:500}.small[data-v-37b9d0a8]{font-size:1.4rem}.big[data-v-37b9d0a8]{font-size:1.8rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
